import Role from ".";

export const roleRoutes = () => [
  {
    path: "/admin/role",
    title: "role",
    layout: "admin",
    routeType: "admin",
    component: Role,
  },
];
